var exports = {
  "Q": "xe7b6e3d6--3c59f1--content",
};

module.exports = exports;
